import { NAMESPACE } from './constants';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const JOB_SELECTION_TOGGLE = `${NAMESPACE}/JOB_SELECTION_TOGGLE`;
export const JOB_SELECTION_CLEAR = `${NAMESPACE}/JOB_SELECTION_CLEAR`;
